<kb-progress-indicator [visible]="(loading$ | async) || false" design="linear"></kb-progress-indicator>
<kb-main-grid [appEditorId]="editorId">
  @for (section of sections(); track section) {
    <ng-template appDynamicSection [section]="section"></ng-template>
  }
</kb-main-grid>
